import { Breadcrumbs, Modal, Page, Pagination, Panel } from "components";
import { format } from "date-fns";
import FileDownload from "js-file-download";
import { debounce } from "lodash";
import queryString from "query-string";
import { useEffect, useState } from "react";
import api from "services/api";
import { inhabitantsAPI } from "services/inhabitantsAPI";
import Swal from "sweetalert2";

import { Access } from "common";
import { Link } from "react-router-dom";

import moment from "moment";
import { ListInhabitant } from "../components";
import { Filters } from "./components";
import "./styles.scss";

export default function List(props) {
  const initialState = {
    cpf: "",
    store: {
      value: "",
      label: "",
    },
    start_at: "",
    end_at: "",
    accessorName: "",
  };
  const breadcrumbs = [
    { name: "Home", to: "/" },
    { name: "PRO", to: "/pro" },
    { name: "Listagem de Clientes PRO", to: "" },
  ];

  const manageAccess = Access.hasPermissions(["manage-inhabitant-segments"]);

  const [inhabitantSegments, setInhabitantSegments] = useState([]);
  const [stores, setStores] = useState([]);
  const [pagination, setPagination] = useState(getCurrentPagination());
  const [totalInhabitantSegments, setTotalInhabitantSegments] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(initialState);
  const [isOpen, setIsOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(undefined);
  const [idsToDelete, setIdsToDelete] = useState([]);
  const [isExporting, setIsExporting] = useState(false);

  function getCurrentPagination() {
    const params = queryString.parse(props.location.search);
    const page = (params.page && Number(params.page)) || 1;
    const per = (params.per && Number(params.per)) || 25;

    return { page, per };
  }

  const handleConfirmDelete = () => {
    if (idsToDelete.length >= 1) {
      removeInhabitantSegment(
        inhabitantSegments[0].segment.segment_id,
        idsToDelete
      );

      setIdsToDelete([]);
    } else if (idToDelete) {
      removeInhabitantSegment(inhabitantSegments[0].segment.segment_id, [
        idToDelete,
      ]);

      setIdToDelete(undefined);
    }

    setIsOpen(false);
  };

  const onChangeFilter = (name, value) => {
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    debounce(getPro, 1000);
  };

  function handleFiltersClean(event) {
    event.preventDefault();
    setFilters(initialState);
  }

  const getPro = () => {
    setLoading(true);

    const options = {
      params: {
        per: pagination.per,
        page: pagination.page,
        store: filters.store.value,
        document: filters.cpf,
        start_at: filters.start_at,
        end_at: filters.end_at,
        accessorName: filters.accessorName,
      },
    };

    inhabitantsAPI
      .get(`/user/inhabitants/segments`, options)
      .then(({ data }) => {
        setInhabitantSegments(data.data.map(({ attributes }) => attributes));

        if (data.meta) {
          setTotalInhabitantSegments(data.meta.total_in_segment);
        }
      })
      .catch(() => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao buscar os clientes PRO, tente novamente mais tarde ou recarregue a página.",
          type: "error",
          confirmButtonText: "Ok",
        });
      })
      .finally(() => setLoading(false));
  };

  const getProExport = () => {
    setIsExporting(true);

    const options = {
      timeout: 60000,
      params: {
        per: pagination.per,
        page: pagination.page,
        store: filters.store.value,
        document: filters.cpf,
        start_at: filters.start_at,
        end_at: filters.end_at,
        accessorName: filters.accessorName,
      },
      responseType: "blob",
    };

    inhabitantsAPI
      .get("/user/inhabitants/segments/export-csv", options)
      .then((response) => {
        FileDownload(
          response.data,
          `inhabitant-segment-${moment().format()}.xls`,
          "application/vnd.ms-excel"
        );
      })
      .catch(() => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro durante a exportação dos clientes PRO, tente novamente mais tarde.",
          type: "error",
          confirmButtonText: "Ok",
        });
      })
      .finally(() => setIsExporting(false));
  };

  const getStores = () => {
    api
      .get("/store/v2/places", {
        params: {
          per: 9999,
          page: 1,
        },
      })
      .then(async ({ data }) => {
        const storeList = await data.data.map(({ id, attributes }) => ({
          id,
          name: attributes.name,
        }));

        setStores([{ id: "", name: "Nenhuma loja selecionada" }, ...storeList]);
      })
      .catch(() => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao buscar as lojas, tente novamente mais tarde ou recarregue a página.",
          type: "error",
          confirmButtonText: "Ok",
        });
      });
  };

  const removeInhabitantSegment = (segment_id, inhabitant_ids) => {
    inhabitantsAPI
      .put(`/user/inhabitants/segments/${segment_id}`, { inhabitant_ids })
      .then(() => {
        getPro();
        setIdsToDelete([]);
      })
      .catch(() => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao remover o habitante do segmento, tente novamente mais tarde ou recarregue a página.",
          type: "error",
          confirmButtonText: "Ok",
        });
      });
  };

  useEffect(() => {
    getPro();
    getStores();
  }, [pagination]);

  useEffect(() => {
    if (props.location.search) {
      const params = queryString.parse(props.location.search);
      const page = params.page;

      if (page > 1) props.history.push("/pro/list");
    }

    setPagination({
      per: pagination.per,
      page: 1,
    });
  }, [filters]);

  useEffect(() => {}, [inhabitantSegments]);

  useEffect(() => {
    const { page, per } = getCurrentPagination();

    if (page !== pagination.page || per !== pagination.per) {
      setPagination({ per, page });
    }
  });

  return (
    <>
      <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
        <div className="removeInfo">
          <h3>Você tem certeza que deseja fazer isso?</h3>
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 30 }}
          >
            <button
              className="button-remove confirm button-add margin-bottom-20 btn-remove"
              onClick={handleConfirmDelete}
            >
              Confirmar
            </button>
            <button
              className="button-remove cancel button-add margin-bottom-20 btn-remove"
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </button>
          </div>
        </div>
      </Modal>

      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Listagem de Clientes PRO</Page.Title>

        <Filters
          onChange={onChangeFilter}
          filters={filters}
          onClean={handleFiltersClean}
          access={manageAccess}
          stores={stores}
        />

        <Panel className="panel-list">
          <Link to="/pro/create" className="button-add margin-bottom-20">
            Adicionar cliente
          </Link>

          {manageAccess && (
            <button
              onClick={() => {
                setIsOpen(true);
              }}
              className="button-add margin-bottom-20 btn-remove"
              disabled={idsToDelete.length === 0}
            >
              Remover selecionados
            </button>
          )}

          <p className="benefits-quantity">
            Habitantes em segmento: <strong>{totalInhabitantSegments}</strong>
          </p>

          <ListInhabitant
            access={manageAccess}
            format={format}
            idsToDelete={idsToDelete}
            inhabitantSegments={inhabitantSegments}
            loading={loading}
            setIdToDelete={setIdToDelete}
            setIdsToDelete={setIdsToDelete}
            setIsOpen={setIsOpen}
          />

          <Pagination
            current={pagination.page}
            per={pagination.per}
            total={totalInhabitantSegments}
            {...props}
          />

          <button
            onClick={getProExport}
            className="button-add margin-bottom-20 btn-remove"
            disabled={isExporting}
          >
            Exportar Planilha
          </button>
        </Panel>
      </Page>
    </>
  );
}
